<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4 translate>internal-facilities.ai-assistant.update-popup.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <gdp-create-update-dictionary-form
      [dictionaryItem]="dictionaryItem"
      (emitValues)="saveDictionaryItem($event)"
      ></gdp-create-update-dictionary-form>
      <div class="submit-container">
        <button class="vox-btn vox-btn-primary" type="button" [disabled]="isButtonDisabled"
        (click)="onSubmit()" [ladda]="loading">
        <span translate>internal-facilities.ai-assistant.update-popup.submit</span>
      </button>
      </div>
    </div>
  </div>
</div>